import { useContext } from 'react';
import { DeliveryOpeningDatesContext, IsDeliveryOpeningDatesOrAfterContext, GetDeliveryOpeningDatesContext } from '../context';
export var useDeliveryOpeningDates = function () { return useContext(DeliveryOpeningDatesContext); };
export var useIsDeliveryOpeningDatesOrAfter = function () { return useContext(IsDeliveryOpeningDatesOrAfterContext); };
export var useGetDeliveryOpeningDates = function () { return useContext(GetDeliveryOpeningDatesContext); };
//# sourceMappingURL=delivery-opening-dates-hooks.js.map